export default __webpack_public_path__ + "scene5_4_bgde7e99.png";